import { forwardRef } from 'react';
import { UpdateIcon } from '@radix-ui/react-icons';

import { comboboxLoadingStyles, comboboxSpinnerStyles } from './combobox.styles';
import type { ComboboxLoadingProps } from './combobox.types';

export const ComboboxLoading = forwardRef<HTMLDivElement, ComboboxLoadingProps>(
  ({ message = 'Loading...', size = 'md', className }, ref) => {
    return (
      <div ref={ref} className={comboboxLoadingStyles({ size, className })} role="status">
        <UpdateIcon
          className={comboboxSpinnerStyles({ size })}
          data-testid="loading-spinner"
          aria-hidden="true"
        />
        <p className="combobox-loading-message">{message}</p>
      </div>
    );
  }
);

ComboboxLoading.displayName = 'ComboboxLoading';
